import type { FC } from "react";

import { Stack, TextField, Typography } from "@mui/material";
import HelpButton from "../../../HelpButton";
import CustomDropdown from "../../../CustomDropdown";
import CustomSwitch from "../../../CustomSwitch";

import { useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { getDaysString } from "../../../../utils/helpers/getDaysString";
import { daysDropdownItems } from "../../../../constants/notifications";

interface RulesTabSummaryModalCaseProps {
  selectedVariant?: string;
  days?: number;
  min?: number;
  withRepeat: boolean;
  onChangeDays?: (value: number) => void;
  onChangeMin?: (value: number) => void;
  onToggleWithRepeat: () => void;
}

export const RulesTabSummaryModalCase: FC<RulesTabSummaryModalCaseProps> = ({
  selectedVariant,
  days,
  min,
  withRepeat,
  onToggleWithRepeat,
  onChangeMin,
  onChangeDays,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1),
        }}
      >
        <HelpButton
          link={process.env.REACT_APP_SUMMARY_STATISTICS_HELP_URL as string}
        />
      </div>
      <Stack>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          my={1}
          spacing={1}
        >
          <CustomDropdown
            width='100%'
            label={
              t(
                "campaign.notifications.settings.displayRules.visitorSummary." +
                  getDaysString(selectedVariant ?? ("orderSummary" as any)),
              ) +
              " " +
              t(
                "campaign.notifications.settings.displayRules.visitorSummary.last",
              )
            }
            value={(days ?? "").toString()}
            items={daysDropdownItems.map(item => {
              return {
                value: item.value,
                title:
                  item.value +
                  " " +
                  t(
                    "campaign.notifications.settings.displayRules." +
                      item.title,
                  ),
              };
            })}
            onChange={event => {
              if (onChangeDays) {
                onChangeDays(Number(event.target.value) as any);
              }
            }}
          />
        </Stack>
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='center'
        >
          <TextField
            sx={{ width: 1 }}
            type='number'
            variant='outlined'
            label={
              t(
                "campaign.notifications.settings.displayRules.visitorSummary.minNumber",
              ) +
              " " +
              t(
                "campaign.notifications.settings.displayRules.visitorSummary." +
                  getDaysString(selectedVariant ?? ("orderSummary" as any)) +
                  "2",
              ) +
              " " +
              t(
                "campaign.notifications.settings.displayRules.visitorSummary.toShow",
              )
            }
            value={min}
            onChange={e => {
              if (onChangeMin) {
                onChangeMin(Number(e.target.value));
              }
            }}
            InputProps={{
              inputProps: { min: 0 },
              style: { height: 44 },
            }}
          />
        </Stack>
      </Stack>

      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <Typography color={theme.palette.natural.t1}>
          {t("campaign.notifications.settings.displayRules.repeatNotification")}
        </Typography>
        <CustomSwitch
          checked={withRepeat}
          onSwitch={() => onToggleWithRepeat()}
        />
      </Stack>
    </>
  );
};
